export default "__VITE_ASSET__DcxQxmsQ__"